import { render, staticRenderFns } from "./df-page-password-forgotten.vue?vue&type=template&id=600452b9&"
import script from "./df-page-password-forgotten.ts?vue&type=script&lang=js&"
export * from "./df-page-password-forgotten.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports